import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { domain } from "../variables/domain";
import { map } from "rxjs/operators";
import { SharedServices } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    null
  );
  loginAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    null
  );
  isAgentUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  constructor(
    public router: Router,
    private http: HttpClient,
    private sharedServices: SharedServices
  ) {
    this.isLogin();
    this.loadToken();
    if (localStorage.getItem("a_n_d")) {
      this.agentUser();
    }
  }
  agentUser() {
    let agentUser = this.sharedServices.isAgent();
    if (agentUser) {
      this.isAgentUser.next(true);
    } else {
      this.isAgentUser.next(false);
    }
  }
  loadToken() {
    const tokenValue = localStorage.getItem("a_n_d");
    if (tokenValue) {
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
  }
  isLogin() {
    let isLoggedIn = this.sharedServices.getLogedIn();
    if (isLoggedIn) {
      this.loginAuthenticated.next(true);
    } else {
      this.loginAuthenticated.next(false);
    }
  }

  ValidateLogin() {}
  ValidateUser(userId: any) {
    return this.http
      .get(domain.ValidateUser + "userId=" + userId)
      .pipe(map((res: any) => res));
  }
  UsersSubscriptionList(userId: any) {
    return this.http
      .get(domain.UsersSubscriptionList  + userId)
      .pipe(map((res: any) => res));
  }
  FreeTrialSubscription(userId: any) {
    return this.http
      .post(domain.FreeTrialSubscription + "userId=" + userId, {})
      .pipe(map((res: any) => res));
  }
  SubscriptionListByServiceId(serviceId: any) {
    return this.http
      .get(domain.SubscriptionListByServiceId  + serviceId)
      .pipe(map((res: any) => res));
  }

  SaveDeviceDetails(object: any) {
    return this.http
      .post(domain.Notification + "SaveDevice", object)
      .pipe(map((res: any) => res));
  }

  AddUserDevice(object: any) {
    return this.http
      .post(domain.AddUserDevice, object)
      .pipe(map((res: any) => res));
  }
}
